<template>
  <form @submit.prevent="handleSubmit">
    <div class="row">
      <div class="col-md-6">
        <label for="post_name" class="form-control-label">
          Título<span class="required">*</span>
        </label>
        <input
          id="post_name"
          v-model="formModel.title"
          :class="[
                        'form-control',
                        v.title.$error ? 'is-invalid' : '',
                      ]"
          type="text"
          placeholder=""
        />
        <p v-if="v.title.$error" class="invalid-feedback mb-0">
          <small>
            {{ v.title.$errors[0].$message }}
          </small>
        </p>
        <label for="lang" class="form-control-label w-100">
          Idioma<span class="required">*</span>
        </label>
        <el-select
            v-model="formModel.lang"
            size="large"
            class="w-100"
        >
          <el-option
              v-for="selectItem in langs"
              :key="selectItem.id"
              :value="selectItem.value"
              :label="selectItem.name"
          />
        </el-select>
        <label for="post_content" class="form-control-label">
          Contenido<span class="required">*</span>
        </label>
        <textarea
            rows="10"
            id="post_content"
            v-model="formModel.content"
            :class="[
                        'form-control',
                        v.content.$error ? 'is-invalid' : '',
                      ]"
            type="text"
            placeholder=""
        />
        <p v-if="v.content.$error" class="invalid-feedback invalid-field mb-0">
          <small>
            {{ v.content.$errors[0].$message }}
          </small>
        </p>
      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-6">
            <label for="post_enabled" class="form-control-label w-100">
              Activo
            </label>
            <el-select
                v-model="formModel.enabled"
                size="large"
                class="w-100"
            >
              <el-option :value="true" label="Si" />
              <el-option :value="false" label="No" />
            </el-select>
          </div>
          <div class="col-md-6">
            <label for="province" class="form-control-label w-100">
              Provincia
            </label>
            <el-select
                v-model="formModel.province"
                size="large"
                class="w-100"
            >
              <el-option
                  v-for="selectItem in provinces"
                  :key="selectItem.id"
                  :value="selectItem.id"
                  :label="selectItem.name"
              />
            </el-select>
          </div>
          <div class="col-12">
            <label for="post_external_link" class="form-control-label">
              Enlace externo
            </label>
            <input
                id="post_external_link"
                v-model="formModel.externalLink"
                :class="[
                        'form-control',
                        v.externalLink.$error ? 'is-invalid' : '',
                      ]"
                placeholder=""
            />
            <p v-if="v.externalLink.$error" class="invalid-feedback mb-0">
              <small>
                {{ v.externalLink.$errors[0].$message }}
              </small>
            </p>
          </div>
          <div class="col-md-12">
            <label for="post_photo" class="form-control-label">
              Imagen<span class="required">*</span>
            </label>
            <a :href="formModel.imageUrl" target="_blank">
              <img v-if="formModel.imageUrl" class="img-thumbnail d-block" width="150" :src="formModel.imageUrl" alt="">
            </a>
            <input
                type="file"
                id="post_photo"
                @change="uploadFile"
                :class="[
                        'form-control',
                      ]"
                placeholder=""
            />
          </div>
        </div>
      </div>

     <div class="col-md-6">
       <div class="row">
         <div class="col-md-6">
           <label for="post_content" class="form-control-label" style="margin-right: 5px;margin-top: 5px;display: block;">
             Fecha de publicación
           </label>
           <el-date-picker
             v-model="formModel.publishedAt"
             type="date"
             value-format="YYYY-MM-DD"
             placeholder="Seleccione un dia"
             :disabled-date="disabledDate"
             :shortcuts="shortcuts"
             :firstDayOfWeek="1"
             :class="v.publishedAt.$errors.length >0 ? 'is-invalid' : ''"
           />
           <p v-if="v.publishedAt.$errors.length >0" class="invalid-feedback  invalid-field mb-0">
             <small>
               {{ v.publishedAt.$errors[0].$message }}
             </small>
           </p>
         </div>
         <div class="col-md-6">
           <label for="post_content" class="form-control-label" style="margin-right: 5px;margin-top: 5px;display: block;">
             Fecha de fin de publicación
           </label>
           <el-date-picker
               v-model="formModel.dueDate"
               type="date"
               value-format="YYYY-MM-DD"
               placeholder="Seleccione un dia"
               :disabled-date="disabledDate"
               :shortcuts="shortcuts"
               :dayjs="Dayjs"
               :class="v.dueDate.$errors.length >0 ? 'is-invalid' : ''"
           />
           <p v-if="v.dueDate.$errors.length >0" class="invalid-feedback  invalid-field mb-0">
             <small>
               {{ v.dueDate.$errors[0].$message }}
             </small>
           </p>
         </div>
       </div>
      </div>
    </div>
    <div class="mt-3">
      <button
        type="submit"
        class="
                      float-end
                      btn btn-primary
                      text-white
                      bg-blue-600
                      rounded-lg
                      border border-primary
                      hover:bg-blue-900
                    "
      >
        {{ buttonText }}
      </button>
      <button
        class="
                      me-2
                      float-end
                      btn btn-primary
                      text-danger
                      bg-white
                      border border-danger
                      rounded-lg
                      hover:bg-blue-900
                    "
        @click="handleCancel"
      >
        Cancelar
      </button>
    </div>
  </form>
</template>

<script setup>
import {ref, defineProps, computed, onMounted} from "vue";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import useVuelidate from "@vuelidate/core";
import {helpers, required} from "@vuelidate/validators";
import Swal from "sweetalert2";
import 'dayjs/locale/en'
import {languageList} from "@/utils/languages";
const store = useStore();
const router = useRouter();
//dayjs.locale('en')
const props = defineProps({
   entity: {
     type: Object,
     required: false
   },
  action: {
     type: String,
    required: true
  }
})

const formModel = ref(props.entity|| {});

const provinces = computed(() => store.state.province.provinces);
const buttonText = computed(() => props.action === 'create' ? 'Crear' : 'Guardar cambios');
const langs = languageList()

const getProvinces = async () => {
  return await store.dispatch("province/getList");
};

onMounted(() => {
  getProvinces();
  if(props.entity.province){
    formModel.value.province = props.entity.province.id
  }
});


const shortcuts = [
  {
    text: 'Hoy',
    value: new Date(),
  }
]

const disabledDate = (time) => {
  let today = new Date();
  let yesterday = new Date(today);

  yesterday.setDate(today.getDate() - 1);
  return time.getTime() < yesterday
}

const rules = computed(() => {
  return {
    title: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    },
    content: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    },
    externalLink: {},
    province: {
      //required: helpers.withMessage("Este campo es obligatorio", required),
    },
    dueDate: {
     // required: helpers.withMessage("Este campo es obligatorio", required),
    },
    publishedAt: {
     // required: helpers.withMessage("Este campo es obligatorio", required),
    },
    lang: {
      required: helpers.withMessage("Este campo es obligatorio", required)
    },
    enabled: {},
  };
});

const v$ = useVuelidate(rules, formModel);
const v = v$.value;

const handleSubmit = () => {
  v$.value.$validate();
  if (!v$.value.$invalid) {
    if(props.action === 'create'){
      createEntity();
    }else{
      updateEntity();
    }

  }
};

const handleCancel = () => {
  router.push({ name: "Noticias", params: {} });
};

const updateEntity = async () => {
  await store.dispatch("post/edit", formModel.value).then(() => {
    Swal.fire({
      position: 'top-end',
      icon: 'success',
      title: 'Noticia editada satisfactoriamente.',
      showConfirmButton: false,
      timer: 3000
    })
    router.push({name: "Noticias"});
  }).catch(async (error) => {
    console.log(error)
    await Swal.fire({
      position: 'top-end',
      icon: 'error',
      title: 'Se ha producido un error.',
      showConfirmButton: false,
      timer: 3000
    });
  })
}

const createEntity = async () => {
    await store.dispatch("post/add", formModel.value).then(async (res) => {
      if (res.status === 200 || res.status === 201) {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Noticia creada satisfactoriamente.',
          showConfirmButton: false,
          timer: 3000
        })
        router.push({name: "Noticias"});
      } else {
        await Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: 'Se ha producido un error.',
          showConfirmButton: false,
          timer: 3000
        })
      }
    })

    };
const createImage = (file) => {
  if (typeof FileReader === "undefined") {
    alert(
      "Su navegador no admite carga de imágenes, actualice su navegador"
    );
    return false;
  }

  for (let i = 0; i < file.length; i++) {
    const reader = new FileReader();
    reader.readAsDataURL(file[i]);
    reader.onload = function(e) {
      formModel.value.file = e.target.result;
      formModel.value.imageUrl = reader.result
    };
  }
}

const uploadFile = (e) => {
  const files = e.target.files || e.dataTransfer.files;
  if (!files.length) return;
  createImage(files);
}

</script>
